'use client';

import { createProvider } from '@/src/shared/utils/zustand';

import type { 
  SubscribeToNewsletterProvider_State
} from './subscribe-to-newsletter-provider.types';
import type { PropsWithChildren } from 'react';

export const useSubscribeToNewsletterProvider = createProvider<SubscribeToNewsletterProvider_State>(
  () => () => ({
    isLoading: false,
    subscribeToNewsletter: async () => {
      throw new Error('Not implemented');
    }
  })
);

export default function SubscribeToNewsletterProvider(props: PropsWithChildren) {
  return (
    <useSubscribeToNewsletterProvider.State>
      {props.children}
    </useSubscribeToNewsletterProvider.State>
  );
}
